module.exports = __webpack_public_path__ + "img/notificacoes@2x.51728242.png";